import {HTTP} from "../_helpers/http";

export default class DmixApi {
    static getCollections() {
        return HTTP.get('/dmix/collection')
            .then(response => response.data)
    }
}